import { isArrayWithLength } from '@natu/utils/isArrayWithLength';

import {
  type BlokItem,
  DynamicRender,
  resolveStoryblokStyles,
  type SBProps,
  type Spacing,
} from '../../../../utils';
import { CaseStudiesGridContent } from './CaseStudiesGridContent';

export type CaseStudyItemProp = BlokItem<'caseStudyCard'>;

export interface SBCaseStudiesGridProps {
  showLoadMoreButton: boolean;
  items?: CaseStudyItemProp[];
  mtMobile?: Spacing;
  mtTablet?: Spacing;
  mtDesktop?: Spacing;
  mbMobile?: Spacing;
  mbTablet?: Spacing;
  mbDesktop?: Spacing;
}

const getCaseStudiesData = ({ items }: { items?: CaseStudyItemProp[] }) =>
  items && items.filter(item => item.component === 'caseStudyCard');

export const SBCaseStudiesGrid = ({ blok }: SBProps<SBCaseStudiesGridProps>) => {
  const {
    showLoadMoreButton,
    items,
    mbDesktop,
    mbMobile,
    mbTablet,
    mtDesktop,
    mtMobile,
    mtTablet,
  } = blok;

  const data = getCaseStudiesData({ items });

  if (!isArrayWithLength(data)) return null;

  const className = resolveStoryblokStyles({
    mt: mtMobile,
    mtTablet,
    mtDesktop,
    mb: mbMobile,
    mbTablet,
    mbDesktop,
  });

  return (
    <CaseStudiesGridContent
      className={className}
      showLoadMoreButton={showLoadMoreButton}
      totalItems={data.length}
    >
      <DynamicRender data={items} />
    </CaseStudiesGridContent>
  );
};
